import { render } from "./FETesting.vue?vue&type=template&id=3bfdd990"
import script from "./FETesting.vue?vue&type=script&lang=js"
export * from "./FETesting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__